exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-date-picker{margin-bottom:0!important}.mx-datepicker{width:130px}", ""]);

// exports
